<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          >
            <CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar
          </a>
        </div>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Solução' : 'Cadastrar Solução' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <label class="mb-0">
                    <b>Status</b>
                  </label>

                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <!-- Title -->
                  <CCol lg="6">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      :disabled="processing"
                    />
                  </CCol>

                  <!-- Link YT -->
                  <CCol lg="6">
                    <CInput
                      v-model="form.video"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>

                  <!-- Description -->
                  <CCol col="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="description"
                        v-model="form.description"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Images -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Imagens
                  </h5>
                </div>

                <CRow>
                  <CCol col="12">
                    <div class="form-group">
                      <FileUploader
                        id="category-image"
                        :uploader-info="{ label: 'Imagem principal*' }"
                        :enable-multiple="false"
                        :enable-crop-on-uploader="true"
                        :enable-edit-on-api-table="false"
                        :max-files="1"
                        :accept-types="acceptTypes"
                        :extensions="extensions"
                        :medias="form.main_image"
                        :min-cropped-width="360"
                        :min-cropped-height="389"
                        uploader-type="banner"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <FileUploader
                        id="category-images"
                        :enable-multiple="true"
                        :uploader-info="{ label: 'Galeria de imagens' }"
                        :enable-crop-on-uploader="false"
                        :enable-edit-on-api-table="true"
                        :max-files="25"
                        :accept-types="acceptTypes"
                        :extensions="extensions"
                        :medias="form.medias"
                        :min-cropped-width="771"
                        :min-cropped-height="428"
                        uploader-type="banner"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="solutions"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <Seo
                      :form="form.seo"
                      :page-title="form.title"
                      :page-description="form.description"
                      :is-edit="!!$route.params.id"
                    />
                  </CCol>
                </CRow>
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="6">
                    <CInput
                      v-model="form.title_en"
                      :disabled="processing"
                      :label="`Título*`"
                    />
                  </CCol>

                  <CCol lg="6">
                    <CInput
                      v-model="form.video_en"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>

                <!-- Description -->
                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.description_en"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="solutions"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.description_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="6">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="6">
                    <CInput
                      v-model="form.video_es"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <label for="spanish-description">Descrição*</label>

                      <TextEditor
                        id="spanish-description"
                        v-model="form.description_es"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="solutions"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.description_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import TextEditor from '@/components/ui/TextEditor'
import Seo from '@/components/ui/Seo'
import TabsStatus from '@/components/ui/TabsStatus'
import CardLog from '@/components/ui/CardLog'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/solution.service'

export default {
  metaInfo: {
    title: 'Solução',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_solutions')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    TextEditor,
    Seo,
    TabsStatus,
    CardLog,
    FriendlyUrl
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        main_image_id: '',
        seo_id: '',
        seo_en_id: '',
        seo_es_id: '',
        title: '',
        title_en: '',
        title_es: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        video: '',
        video_en: '',
        video_es: '',
        description: '',
        description_en: '',
        description_es: '',
        order: '',
        status: true,
        status_en: false,
        status_es: false,
        medias: [],
        main_image: [],
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        }
      },
      form: {},
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      processing: false,
      new: true,
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      activeTabIndex: 0,
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            video: data.video,
            video_en: data.video_en,
            video_es: data.video_es,
            description: data.description,
            description_en: data.description_en,
            description_es: data.description_es,
            order: data.order,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            medias: data.medias,
            main_image: data.main_image,
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            }
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      const validateYoutube = (link) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
        const match = link.match(regExp)

        return match
      }

      const openModal = (message) => {
        this.modal = {
          show: true,
          title: 'Erro',
          message: message,
          color: 'danger'
        }
      }

      if (this.form.video) {
        const link = validateYoutube(this.form.video)
        if (!link) {
          this.processing = false
          openModal('a URL do youtube deve ser um link do youtube')
          return
        }
      }
      if (this.form.video_en) {
        const link = validateYoutube(this.form.video_en)
        if (!link) {
          this.processing = false
          openModal('a URL do youtube em inglês deve ser um link do youtube')
          return
        }
      }
      if (this.form.video_es) {
        const link = validateYoutube(this.form.video_es)
        if (!link) {
          this.processing = false
          openModal('a URL do youtube em espanhol deve ser um link do youtube')
          return
        }
      }

      let response
      let message

      const data = {
        id: this.$route.params.id,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        video: this.form.video,
        video_en: this.form.video_en,
        video_es: this.form.video_es,
        description: this.form.description,
        description_en: this.form.description_en,
        description_es: this.form.description_es,
        status: this.form.status,
        status_en: this.form.status_en,
        status_es: this.form.status_es,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description,
        main_image_id: this.form.main_image && this.form.main_image.length ? this.form.main_image[0].id : null,
        medias: this.form.medias.map((media) => media.id)
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Solução foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Solução foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
